import { calendarList } from "../../../calendar/api/calendar-api";
import orderBy from "lodash/orderBy";
import Cookies from 'js-cookie';

export const GET_CALENDARS = "GET_CALENDARS";
export const ERROR_CALENDARS = "ERROR_CALENDARS";
export const SELECT_CALENDAR = "SELECT_CALENDAR";
export const CHECK_CALENDAR = "CHECK_CALENDAR";
export const SET_CONFIG_HOURS_CALENDAR = "SET_CONFIG_HOURS_CALENDAR";

const mergeCalendarsPreservingOrder = (fetchedCalendars = [], previousCalendars = []) => {
  if (!previousCalendars || previousCalendars.length === 0) {
    return fetchedCalendars;
  }

  const fetchedById = new Map(fetchedCalendars.map(calendar => [calendar.id, calendar]));

  const mergedCalendars = previousCalendars
    .filter(calendar => fetchedById.has(calendar.id))
    .map(calendar => {
      const fetchedCalendar = fetchedById.get(calendar.id);
      return {
        ...calendar,
        ...fetchedCalendar,
        checked: calendar.checked ?? fetchedCalendar.checked
      };
    });

  fetchedCalendars.forEach(calendar => {
    if (!previousCalendars.some(previousCalendar => previousCalendar.id === calendar.id)) {
      mergedCalendars.push(calendar);
    }
  });

  return mergedCalendars;
};

export const getCalendars = (userId, mailAccount, lexonToken, preCalendars) => dispatch => {
  calendarList(userId, mailAccount, lexonToken).then(calendars => {
    let resourceCalendarData = orderBy(calendars?.items || [], "primary");
    
    // Handle empty calendar list (e.g., due to API errors)
    if (!resourceCalendarData || resourceCalendarData.length === 0) {
      console.warn('[Calendars] No calendars available');
      dispatch({
        type: GET_CALENDARS,
        payload: []
      });
      return;
    }
    
    const storedSelection = Cookies.get(`Lefebvre.ImapCalendarsSelection`);

    if (storedSelection) {
      const calIds = storedSelection.split('|');
      calIds.pop();

      if (calIds.length > 0) {
        calIds.forEach(calId => {
          const resultCalendar = resourceCalendarData.find(x => x.id == calId);
          if (resultCalendar) {
            resultCalendar.checked = true;
          }
        });

        if (!resourceCalendarData.some(x => x.checked === true) && resourceCalendarData[0]) {
          resourceCalendarData[0].checked = true;

          if (window.REACT_APP_ENVIRONMENT === 'LOCAL') {
            Cookies.set(`Lefebvre.ImapCalendarsSelection`, `${resourceCalendarData[0].id}|`, {
              domain: 'localhost',
              expires: 365
            });
          } else {
            Cookies.set(`Lefebvre.ImapCalendarsSelection`, `${resourceCalendarData[0].id}|`, {
              domain: 'lefebvre.es',
              sameSite: 'None',
              secure: true,
              expires: 365
            });
          }
        }
      }
    } else if (resourceCalendarData[0]) {
      resourceCalendarData[0].checked = true;

      if (window.REACT_APP_ENVIRONMENT === 'LOCAL') {
        Cookies.set(`Lefebvre.ImapCalendarsSelection`, `${resourceCalendarData[0].id}|`, {
          domain: 'localhost',
          expires: 365
        });
      } else {
        Cookies.set(`Lefebvre.ImapCalendarsSelection`, `${resourceCalendarData[0].id}|`, {
          domain: 'lefebvre.es',
          sameSite: 'None',
          secure: true,
          expires: 365
        });
      }
    }

    resourceCalendarData = mergeCalendarsPreservingOrder(resourceCalendarData, preCalendars);

    dispatch({
      type: GET_CALENDARS,
      payload: resourceCalendarData
    });
  }).catch(error => {
    dispatch({
      type: ERROR_CALENDARS,
      payload: error.message
    });
    console.error("Error fetching calendars:", error.message);
  });
};

export const clearErrorCalendars = () => ({
  type: ERROR_CALENDARS,
  payload: null
});

export const selectCalendar = (calendarId, checked) => ({
  type: SELECT_CALENDAR,
  payload: {calendarId, checked}
});

export const checkCalendar = (calendarId, checked) => dispatch => {
  dispatch({
    type: CHECK_CALENDAR,
    payload: {calendarId, checked}
  });
};

export const setConfigHoursCalendar = calendarTimeScale => dispatch => {
  dispatch({
    type: SET_CONFIG_HOURS_CALENDAR,
    payload: {calendarTimeScale}
  });
};
